import request from './axios';

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.categoryCode 姓名
 * @returns {Promise<Object>} 返回提交结果
 */
// 查询菜单详情(单文章)
export function artcleSingle(data) {
  return request({
    url: '/website/artcle/single',  // 添加/api前缀
    method: 'post',
    data
  });
}
// 查询菜单详情(列表)
export function artcleMulti(data) {
  return request({
    url: '/website/artcle/multi',  // 添加/api前缀
    method: 'post',
    data
  });
}

// 查询医生列表
export function doctorPage(data) {
  return request({
    url: '/website/doctor/page',  // 添加/api前缀
    method: 'post',
    data
  });
}

// 查询领导团队
export function doctorTeamList(data) {
  return request({
    url: '/website/doctor/list',  // 添加/api前缀
    method: 'post',
    data
  });
}

// 查询列表文章信息
export function artcleInfo(data) {
  return request({
    url: '/website/artcle/info',  // 添加/api前缀
    method: 'post',
    data
  });
}

// 查询医生信息
export function doctorInfo(data) {
  return request({
    url: '/website/doctor/info',  // 添加/api前缀
    method: 'post',
    data
  });
}

export function departmentInfo(data) {
  return request({
    url: '/website/department/info',  // 添加/api前缀
    method: 'post',
    data
  });
}